import React from "react";
import Carousel from "react-bootstrap/Carousel";
import styled from "styled-components";

export default function CarouselComponent({
	children,
	controls,
	whiteControls,
}) {
	return (
		<CarouselContainer whiteControls={whiteControls}>
			<Carousel controls={controls ? true : false}>{children}</Carousel>
		</CarouselContainer>
	);
}

const CarouselContainer = styled.div`
	.carousel-control-next-icon,
	.carousel-control-prev-icon {
		filter: ${(props) => props.whiteControls || "invert(1)"} !important;
	}
`;
